require('./vendors/jquery-ui');

require('./vendors/jquery-ui/langs/jquery.ui.datepicker-fr');

require('./vendors/matchMedia');
require('./vendors/matchMedia.addListener');
require('./vendors/jquery.mobile.events');
require('./vendors/shim/base64');

require('./vendors/plugins/jquery.fancybox');
require('./vendors/plugins/jquery.fancybox-media');
require('./vendors/plugins/jquery.ba-outside-events');
require('./vendors/plugins/jquery.pjax');

window.PubSub = require('./vendors/jquery.pubsub');
window._ = require('lodash');
window.scrollMonitor = require('scrollmonitor');
